type State = {
  state: string;
  code: string;
};

export const stateConfig: { [locale: string]: State[] } = {
  de_DE: [
    {
      state: 'Brandenburg',
      code: 'BB',
    },
    {
      state: 'Berlin',
      code: 'BE',
    },
    {
      state: 'Baden-Württemberg',
      code: 'BW',
    },
    {
      state: 'Bayern',
      code: 'BY',
    },
    {
      state: 'Bremen',
      code: 'HB',
    },
    {
      state: 'Hessen',
      code: 'HE',
    },
    {
      state: 'Hamburg',
      code: 'HH',
    },
    {
      state: 'Mecklenburg-Vorpommern',
      code: 'MV',
    },
    {
      state: 'Niedersachsen',
      code: 'NI',
    },
    {
      state: 'Nordrhein Westfalen',
      code: 'NW',
    },
    {
      state: 'Rheinland Pfalz',
      code: 'RP',
    },
    {
      state: 'Schleswig-Holstein',
      code: 'SH',
    },
    {
      state: 'Saarland',
      code: 'SL',
    },
    {
      state: 'Sachsen',
      code: 'SN',
    },
    {
      state: 'Sachsen-Anhalt',
      code: 'ST',
    },
    {
      state: 'Thüringen',
      code: 'TH',
    },
  ],
  en_CA: [
    {
      state: 'Alberta',
      code: 'AB',
    },
    {
      state: 'British Columbia',
      code: 'BC',
    },
    {
      state: 'Manitoba',
      code: 'MB',
    },
    {
      state: 'New Brunswick',
      code: 'NB',
    },
    {
      state: 'Newfoundland and Labrador',
      code: 'NL',
    },
    {
      state: 'Nova Scotia',
      code: 'NS',
    },
    {
      state: 'Northwest Territories',
      code: 'NT',
    },
    {
      state: 'Nunavut',
      code: 'NU',
    },
    {
      state: 'Ontario',
      code: 'ON',
    },
    {
      state: 'Prince Edward Island',
      code: 'PE',
    },
    {
      state: 'Quebec',
      code: 'QC',
    },
    {
      state: 'Saskatchewan',
      code: 'SK',
    },
    {
      state: 'Yukon Territories',
      code: 'YT',
    },
  ],
  fr_CA: [
    {
      state: 'Alberta',
      code: 'AB',
    },
    {
      state: 'British Columbia',
      code: 'BC',
    },
    {
      state: 'Manitoba',
      code: 'MB',
    },
    {
      state: 'New Brunswick',
      code: 'NB',
    },
    {
      state: 'Newfoundland and Labrador',
      code: 'NL',
    },
    {
      state: 'Nova Scotia',
      code: 'NS',
    },
    {
      state: 'Northwest Territories',
      code: 'NT',
    },
    {
      state: 'Nunavut',
      code: 'NU',
    },
    {
      state: 'Ontario',
      code: 'ON',
    },
    {
      state: 'Prince Edward Island',
      code: 'PE',
    },
    {
      state: 'Quebec',
      code: 'QC',
    },
    {
      state: 'Saskatchewan',
      code: 'SK',
    },
    {
      state: 'Yukon Territories',
      code: 'YT',
    },
  ],
  en_US: [
    {
      state: 'Armed Forces Americas',
      code: 'AA',
    },
    {
      state: 'Armed Forces Europe',
      code: 'AE',
    },
    {
      state: 'Alaska',
      code: 'AK',
    },
    {
      state: 'Alabama',
      code: 'AL',
    },
    {
      state: 'Armed Forces Pacific',
      code: 'AP',
    },
    {
      state: 'Arkansas',
      code: 'AR',
    },
    {
      state: 'American Samoa',
      code: 'AS',
    },
    {
      state: 'Arizona',
      code: 'AZ',
    },
    {
      state: 'California',
      code: 'CA',
    },
    {
      state: 'Colorado',
      code: 'CO',
    },
    {
      state: 'Connecticut',
      code: 'CT',
    },
    {
      state: 'District of Columbia',
      code: 'DC',
    },
    {
      state: 'Delaware',
      code: 'DE',
    },
    {
      state: 'Florida',
      code: 'FL',
    },
    {
      state: 'Federated Micronesia',
      code: 'FM',
    },
    {
      state: 'Georgia',
      code: 'GA',
    },
    {
      state: 'Guam',
      code: 'GU',
    },
    {
      state: 'Hawaii',
      code: 'HI',
    },
    {
      state: 'Iowa',
      code: 'IA',
    },
    {
      state: 'Idaho',
      code: 'ID',
    },
    {
      state: 'Illinois',
      code: 'IL',
    },
    {
      state: 'Indiana',
      code: 'IN',
    },
    {
      state: 'Kansas',
      code: 'KS',
    },
    {
      state: 'Kentucky',
      code: 'KY',
    },
    {
      state: 'Louisiana',
      code: 'LA',
    },
    {
      state: 'Massachusetts',
      code: 'MA',
    },
    {
      state: 'Maryland',
      code: 'MD',
    },
    {
      state: 'Maine',
      code: 'ME',
    },
    {
      state: 'Marshall Islands',
      code: 'MH',
    },
    {
      state: 'Michigan',
      code: 'MI',
    },
    {
      state: 'Minnesota',
      code: 'MN',
    },
    {
      state: 'Missouri',
      code: 'MO',
    },
    {
      state: 'Northern Mariana Islands',
      code: 'MP',
    },
    {
      state: 'Mississippi',
      code: 'MS',
    },
    {
      state: 'Montana',
      code: 'MT',
    },
    {
      state: 'North Carolina',
      code: 'NC',
    },
    {
      state: 'North Dakota',
      code: 'ND',
    },
    {
      state: 'Nebraska',
      code: 'NE',
    },
    {
      state: 'New Hampshire',
      code: 'NH',
    },
    {
      state: 'New Jersey',
      code: 'NJ',
    },
    {
      state: 'New Mexico',
      code: 'NM',
    },
    {
      state: 'Nevada',
      code: 'NV',
    },
    {
      state: 'New York',
      code: 'NY',
    },
    {
      state: 'Ohio',
      code: 'OH',
    },
    {
      state: 'Oklahoma',
      code: 'OK',
    },
    {
      state: 'Oregon',
      code: 'OR',
    },
    {
      state: 'Pennsylvania',
      code: 'PA',
    },
    {
      state: 'Puerto Rico',
      code: 'PR',
    },
    {
      state: 'Palau',
      code: 'PW',
    },
    {
      state: 'Rhode Island',
      code: 'RI',
    },
    {
      state: 'South Carolina',
      code: 'SC',
    },
    {
      state: 'South Dakota',
      code: 'SD',
    },
    {
      state: 'Tennessee',
      code: 'TN',
    },
    {
      state: 'Texas',
      code: 'TX',
    },
    {
      state: 'United States Minor Outlying Islands',
      code: 'UM',
    },
    {
      state: 'Utah',
      code: 'UT',
    },
    {
      state: 'Virginia',
      code: 'VA',
    },
    {
      state: 'US Virgin Islands',
      code: 'VI',
    },
    {
      state: 'Vermont',
      code: 'VT',
    },
    {
      state: 'Washington',
      code: 'WA',
    },
    {
      state: 'Wisconsin',
      code: 'WI',
    },
    {
      state: 'West Virginia',
      code: 'WV',
    },
    {
      state: 'Wyoming',
      code: 'WY',
    },
  ],
};
